import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, keyframes } from "@mui/material";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import { styled } from "@mui/system";
import RocketImg from "../../assets/shuttle.png";

interface UpgradeDialogV2Props {
  open: boolean;
  onClose: () => void;
  title: string;
  subtitle: string;
  requestedFeature: "qr" | "linktree" | "form"
}

const StyledDialog = styled(Dialog)({
  "& .MuiPaper-root": {
    borderRadius: 16,
    backgroundColor: "#1a2a6c",
    color: "white",
    overflow: "visible",
    padding: "20px",
    textAlign: "center",
  },
});

const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
`;

const UpgradeDialogV2: React.FC<UpgradeDialogV2Props> = ({ open, onClose, title, subtitle, requestedFeature }) => {
  const handleUpgrade = () => {
    if(requestedFeature === "linktree" || requestedFeature === "form"){
        window.parent.postMessage(
            { action: "redirect", url: "https://app.qrcompose.com/register/advanced/monthly" },
            "*"
        );
    } else {
        window.parent.postMessage(
          { action: "redirect", url: "https://app.qrcompose.com/register/starter/monthly" },
          "*"
        );
    }
  };

  // Countdown Timer for Urgency
  const [timeLeft, setTimeLeft] = useState(12 * 60 * 60); // 12 hours in seconds

  useEffect(() => {
    if (!open) return;
    const timer = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, [open]);

  const formatTime = (seconds: number) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hours}h ${minutes}m ${secs}s`;
  };

  return (
    <StyledDialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <Box sx={{ position: "relative", textAlign: "center" }}>
        <Box
          component="img"
          src={RocketImg}
          alt="Rocket Launch"
          sx={{ position: "absolute", top: "-75px", right: "15px", width: "90px" }}
        />
        <DialogTitle sx={{ fontWeight: "bold", fontSize: "1.5rem" }}>{title}</DialogTitle>
      </Box>
      
      <DialogContent>
        <Typography sx={{ opacity: 0.8 }}>{subtitle}</Typography>
        <Typography sx={{ fontWeight: "bold", color: "#ffeb3b", mt: 2 }}>
          Upgrade Now & Get up to 30 Days Free – Limited Time!
        </Typography>
        <Typography sx={{ fontSize: "0.9rem", opacity: 0.8, mt: 1 }}>
          Claim Your Free Trial Before It Expires! No credit card needed!
        </Typography>
        <Typography sx={{ fontSize: "1rem", fontWeight: "bold", color: "#ff5722", mt: 2 }}>
          🕒 Offer expires in: {formatTime(timeLeft)}
        </Typography>
      </DialogContent>
      
      <DialogActions sx={{ justifyContent: "center", flexDirection: "column", gap: 1 }}>
        <Button
          onClick={handleUpgrade}
          startIcon={<RocketLaunchIcon />}
          sx={{ 
            textTransform: "none", 
            backgroundColor: "#4caf50", 
            color: "#fff", 
            borderRadius: "20px", 
            padding: "10px 20px", 
            animation: `${pulse} 1.5s infinite` 
          }}
          variant="contained"
        >
          Claim My 30-Day Free Trial
        </Button>
        <Typography
          sx={{ color: "#ffeb3b", fontSize: "0.9rem", fontWeight: "bold", mt: 1 }}
        >
          ⬆ Don't Miss Out! ⬆
        </Typography>
        {/* <Button
          onClick={onClose}
          sx={{ textTransform: "none", color: "#ffeb3b", mt: 1 }}
        >
          Maybe Later – Keep Exploring
        </Button> */}
      </DialogActions>
    </StyledDialog>
  );
};

export default UpgradeDialogV2;
